<div class="app-home">

  <header>
    <h1>Stations</h1>
  </header>

  <div class="container-fluid">
    <!-- Favorites Header section -->
    <div
      class="row"
      *ngIf="
        !(markets?.length > 0 || formats?.length > 0 || stations?.length > 0) &&
        favoriteStationsData.length > 0
      "
    >
      <div class="col-lg-12 p-0">
        <span class="subheader">STATIONS</span>
        <h1 class="header1">Favorites</h1>
      </div>
    </div>

    <!-- List of Favorite Stations section -->
    <div
      class="row"
      *ngIf="
        !(markets?.length > 0 || formats?.length > 0 || stations?.length > 0) &&
        favoriteStationsData.length > 0
      "
    >
      <div
        [class]="cardsGridClass"
        style="min-width: 230px; max-width: 240px"
        *ngFor="let station of favoriteStationsData"
      >
        <app-station-card
          [stationItem]="station"
          (favoriteChange)="favoriteChangeEvent($event)"
          (playLive)="play($event)"
          (gotoTranscriptions)="showTranscriptions($event)"
        >
        </app-station-card>
      </div>
    </div>

    <div class="row">
      <div class="filters-section">
        <app-multi-dropbox
          class="drop-box-item"
          cssClassToApply="dropbox-145"
          popupPositionLeft="44"
          appearance="outline"
          [(ngModel)]="markets"
          placeholder="Find a market"
          placeholderLabel="Market"
          noEntriesFoundLabel="No market found"
          #marketMulti
          (modelChange)="loadFormats(); loadStations(); searchChange()"
        ></app-multi-dropbox>

        <app-multi-dropbox
          class="drop-box-item"
          popupPositionLeft="44"
          cssClassToApply="dropbox-145"
          appearance="outline"
          [(ngModel)]="formats"
          placeholderLabel="Format"
          placeholder="Find a format"
          noEntriesFoundLabel="No Format found"
          #formatMulti
          (modelChange)="loadStations(); searchChange()"
        ></app-multi-dropbox>

        <app-multi-dropbox
          class="drop-box-item"
          popupPositionLeft="44"
          cssClassToApply="dropbox-145"
          appearance="outline"
          [(ngModel)]="stations"
          placeholderLabel="Station"
          placeholder="Find a station"
          noEntriesFoundLabel="No station found"
          #stationMulti
          (modelChange)="searchChange()"
          [showStationBadge]="true"
        ></app-multi-dropbox>

        <app-multi-dropbox
          [(ngModel)]="filterToApply"
          class="drop-box-item"
          popupPositionLeft="-78"
          placeholder="Select a filter"
          iconClass="material-icons dropbox-search-xl"
          cssClassToApply="dropbox-w-145 multi-dropbox-custom"
          [hideFilterButton]="true"
          [allowMultiple]="false"
          cssClassToApply="dropbox-145"
          appearance="outline"
          placeholderLabel="Saved Filter"
          noEntriesFoundLabel="No filter found"
          #savedFiltersMulti
          (selectionChanged)="applySavedFilter($event)"
          [enableEdit]="true"
          (editIconClicked)="editStationFilter($event)"
        ></app-multi-dropbox>
      </div>
    </div>

    <!-- Applied Filters section -->
    <div
      [ngClass]="
        isSafari
          ? 'row chip-body applied-filters-no-border'
          : 'row chip-body applied-filters'
      "
      [hidden]="
        !(markets?.length > 0 || formats?.length > 0 || stations?.length > 0)
      "
    >
      <div class="chip-title">Filtered by:</div>
      <div class="chip-content">
        <div class="chip-item">
          <mat-chip-list>
            <mat-chip
              color="primary"
              selected
              *ngFor="let market of markets"
              [selectable]="selectable"
              (removed)="removeMarket(market)"
            >
              {{ market.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <mat-chip-list>
            <mat-chip
              color="primary"
              selected
              *ngFor="let format of formats"
              [selectable]="selectable"
              (removed)="removeFormat(format)"
            >
              {{ format.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
          <mat-chip-list>
            <mat-chip
              color="primary"
              selected
              *ngFor="let station of stations"
              [selectable]="selectable"
              (removed)="removeStation(station)"
            >
              {{ station.name }}
              <app-badge-station class="badge-chip" [mergedStation]="station.mergedStation"></app-badge-station>
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
      </div>
      <div style="min-width: 176px">
        <button
          mat-button
          class="float-right primary-button"
          (click)="openDialog(true)"
        >
          SAVE
        </button>
        <button mat-button class="float-right" (click)="clearFilters($event)">
          CLEAR
        </button>
      </div>
    </div>

    <!-- List of Filtered Stations section -->
    <div
      infiniteScroll
      [infiniteScrollDistance]="4"
      [infiniteScrollThrottle]="pageSize"
      (scrolled)="onScroll()"
    >
      <div *ngFor="let market of uniqueMarkets">
        <div class="row">
          <div class="col-lg-12 p-0">
            <span class="subheader">STATIONS</span>
            <h1 class="header1">{{ market | marketFormat }}</h1>
          </div>
        </div>
        <div class="row">
          <div
            [class]="cardsGridClass"
            style="min-width: 230px; max-width: 240px"
            *ngFor="let station of getMarketStations(market)"
          >
            <app-station-card
              [stationItem]="station"
              (favoriteChange)="favoriteChangeEvent($event)"
              (playLive)="play($event)"
              (gotoTranscriptions)="showTranscriptions($event)"
            >
            </app-station-card>
          </div>
        </div>
      </div>
    </div>

    <!-- Favorites Header section -->
    <div
      class="row"
      *ngIf="
        (markets?.length > 0 || formats?.length > 0 || stations?.length > 0) &&
        favoriteStationsData.length > 0
      "
    >
      <div class="col-lg-12 p-0">
        <span class="subheader">STATIONS</span>
        <h1 class="header1">Favorites</h1>
      </div>
    </div>

    <!-- List of Favorite Stations section -->
    <div
      class="row"
      *ngIf="
        (markets?.length > 0 || formats?.length > 0 || stations?.length > 0) &&
        favoriteStationsData.length > 0
      "
    >
      <div
        [class]="cardsGridClass"
        style="min-width: 230px; max-width: 240px"
        *ngFor="let station of favoriteStationsData"
      >
        <app-station-card
          [stationItem]="station"
          (favoriteChange)="favoriteChangeEvent($event)"
          (playLive)="play($event)"
          (gotoTranscriptions)="showTranscriptions($event)"
        >
        </app-station-card>
      </div>
    </div>
  </div>
</div>
